document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.stats-success');
  if (!section) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const easeOut = t => 1 - Math.pow(1 - t, 3);

  const resetNumbers = () => {
    section.querySelectorAll('.stat-number__value').forEach(el => {
      el.dataset.target = el.textContent.trim();
      el.textContent = '0';
    });
  };

  const resetDonuts = () => {
    section.querySelectorAll('.stat-donut').forEach(donut => {
      const circle = donut.querySelector('.stat-donut__progress');
      const valueEl = donut.querySelector('.stat-donut__value');
      const r = 52;
      const c = 2 * Math.PI * r;

      circle.style.strokeDasharray = c;
      circle.style.strokeDashoffset = c;
      valueEl.textContent = '0%';
    });
  };

  const animateNumber = (el, target) => {
    if (prefersReducedMotion) {
      el.textContent = target;
      return;
    }

    const start = performance.now();
    const duration = 1200;

    const tick = now => {
      const p = Math.min((now - start) / duration, 1);
      el.textContent = Math.floor(easeOut(p) * target);
      if (p < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  };

  const animateDonut = donut => {
    const pct = Number(donut.dataset.percentage) || 0;
    const circle = donut.querySelector('.stat-donut__progress');
    const valueEl = donut.querySelector('.stat-donut__value');
    const r = 52;
    const c = 2 * Math.PI * r;

    if (prefersReducedMotion) {
      circle.style.strokeDashoffset = c - (pct / 100) * c;
      valueEl.textContent = `${pct}%`;
      return;
    }

    const start = performance.now();
    const duration = 1200;

    const tick = now => {
      const p = Math.min((now - start) / duration, 1);
      const eased = easeOut(p);
      const current = Math.round(eased * pct);

      circle.style.strokeDashoffset = c - (current / 100) * c;
      valueEl.textContent = `${current}%`;

      if (p < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  };

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          resetNumbers();
          resetDonuts();

          section.querySelectorAll('.stat-number__value')
            .forEach(el => animateNumber(el, Number(el.dataset.target)));

          section.querySelectorAll('.stat-donut')
            .forEach(animateDonut);
        }
      });
    },
    { threshold: 0.4 }
  );

  observer.observe(section);
});
